import { z } from 'zod';
/**
 * Every rejection the client can receive, over HTTP or WS, uses this shape.
 * `correlationId` ties the client-visible error to the server log line (§16.3),
 * which is what makes "it said something went wrong" a one-minute investigation.
 */
export const ERROR_CODES = [
    'BAD_REQUEST',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'NOT_FOUND',
    'SEAT_TAKEN',
    'WINDOW_CLOSED',
    /** The MW seat still owes a decision on a live track (decision M4-D13). */
    'MW_TRACKS_OPEN',
    'RATE_LIMITED',
    'PAYLOAD_TOO_LARGE',
    'ORIGIN_REJECTED',
    'UNSUPPORTED_PROTOCOL_VERSION',
    'INTERNAL',
];
export const zErrorCode = z.enum(ERROR_CODES);
export const zApiError = z.object({
    code: zErrorCode,
    message: z.string(),
    correlationId: z.string().optional(),
});
/** HTTP status for each code, so handlers never hand-pick one inconsistently. */
export const ERROR_HTTP_STATUS = Object.freeze({
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    SEAT_TAKEN: 409,
    WINDOW_CLOSED: 409,
    MW_TRACKS_OPEN: 409,
    RATE_LIMITED: 429,
    PAYLOAD_TOO_LARGE: 413,
    ORIGIN_REJECTED: 403,
    UNSUPPORTED_PROTOCOL_VERSION: 426,
    INTERNAL: 500,
});
//# sourceMappingURL=errors.js.map